import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.85, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const LineReveal = ({ children, delay = 0, className = "", immediate = false }) => (
    <motion.span
        className={`block overflow-hidden ${className}`}
        initial="hidden"
        {...(immediate
            ? { animate: "visible" }
            : { whileInView: "visible", viewport: { once: true, margin: "-40px" } })}
    >
        <motion.span
            className="block will-change-transform"
            variants={{
                hidden: { y: "112%" },
                visible: { y: 0, transition: { duration: 1, delay, ease: EASE } },
            }}
        >
            {children}
        </motion.span>
    </motion.span>
);

export const Kicker = ({ children, light = false }) => (
    <p className={`font-mono text-[11px] sm:text-xs tracking-[0.28em] uppercase flex items-center gap-3 ${light ? "text-brand-ember" : "text-brand-red"}`}>
        <span className={`inline-block h-px w-8 ${light ? "bg-brand-ember" : "bg-brand-red"}`} />
        {children}
    </p>
);
